import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import Landing from './landing/Landing';

// StrictMode kullanılmıyor: ajan akışı tek seferlik başlatılır.
function Root() {
  const [isDemo, setIsDemo] = useState(window.location.hash === '#/demo');
  useEffect(() => {
    const onHash = () => { setIsDemo(window.location.hash === '#/demo'); window.scrollTo(0, 0); };
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);
  return isDemo ? <App /> : <Landing />;
}

ReactDOM.createRoot(document.getElementById('root')).render(<Root />);
